module.exports = __webpack_public_path__ + "static/media/close.c51625ce.svg";